module.exports = __webpack_public_path__ + "static/media/Governance.307b63ec.svg";